// ----------- Component for the backtesting page of the application ----------------
// ----------------------------------------------------------------------------------
// import all necessary dependencies and components
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import PredictionsPanel from './PredictionsPanel';
import PanelWrapper from './PanelWrapper';
import './HomePage.css';

// create the backtesting page component
const BacktestingPage = () => { 
  const [selectedStock, setSelectedStock] = useState('AAPL'); // state to hold the selected stock, default is AAPL
  const [timeframe, setTimeframe] = useState('2015-01-01|2025-12-31'); // state to hold the selected timeframe, default is from 2015 to 2025

  return ( // return the JSX component
    <div className="dashboard">
      <Sidebar selectedStock={selectedStock} onSelectStock={setSelectedStock} timeframe={timeframe} />

      <div className="main-content">
        <Header stockData={{ symbol: selectedStock }} timeframe={timeframe} onTimeframeChange={setTimeframe} /> 
        
        <div className="backtesting-grid">
          <PanelWrapper id="predictions" className="grid-panel">
            <PredictionsPanel /> {/* include the predictions panel */}
          </PanelWrapper>

        </div>
      </div>
    </div>
  );
};

export default BacktestingPage; // export the backtesting page component

